import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreService } from '../core.service'
import { FormsModule } from '@angular/forms';
import { ProfileService } from '../profile/profile.service';
import { PlayerService } from '../tvbox/player.service';

@Component({
	selector: 'app-footer',
	imports: [
		CommonModule,
		FormsModule
	],
	templateUrl: './footer.component.html',
	styleUrl: './footer.component.scss'
})
export class FooterComponent {

	constructor( public core: CoreService, public profile: ProfileService, public player: PlayerService ){
		this.core.component_footer = this;
	}

	get contact_email(){
		try { return this.core.stateshot['configs']['contact_email']; } catch(e){ return ""; }
	}

	reportConfirming: boolean = false;
	close_report_panel(event, node): void {
		if( event.target == node ) this.reportConfirming = false;
	}

	report_type = '';
	report_include_log = true;
	report_description = '';
	report_error_message = null;

	async report_submit(){
		let js_log = this.report_include_log ? this.player.last_player_error : false
		this.report_error_message = null;

		let payload = {
			'type': this.report_type,
			'js_log': js_log,
			'description': this.report_description,
		}

		let response = await this.core.json_request( "POST", "/api/v1/accounting/create_a_ticket", payload, { withCredentials: true } );
		if( !response.ok ){
			this.report_error_message = 'Something went wrong while sending the report!';
			return;
		}

		this.report_type = '';
		this.report_include_log = true;
		this.report_description = '';
		this.reportConfirming = false;
		this.core.events.emit("report.submitted");
	}

	login_click(){
		if( this.profile.is_authenticated ) return;

		this.core.events.emit("profile.auth-required");
		this.reportConfirming = false;
	}

}
